import React from "react";
import PropTypes from "prop-types";

import styles from "./variables-preview.module.scss";

const VariablesPreview = ({ onAddVariables }) => {
  return (
    <div className={styles["preview-cantainer-empty"]}>
      <button
        className={styles["add-variables-button"]}
        type="button"
        onClick={onAddVariables}
      >
        + Add variables
      </button>
    </div>
  );
};

VariablesPreview.propTypes = {
  onAddVariables: PropTypes.func
};

VariablesPreview.defaultProps = {
  onAddVariables: () => {}
};

export default VariablesPreview;
